import { BarElement, CategoryScale, Chart as ChartJS, ChartData, ChartOptions, LinearScale } from "chart.js";
import { Bar } from "react-chartjs-2";

import { Container } from "./styles";

ChartJS.register(BarElement, CategoryScale, LinearScale);

const previewBars = [
  43, 51, 48, 55, 60, 49, 43, 51, 60, 69, 63, 48, 55, 60, 55, 48, 55, 43, 38, 33, 30, 30, 30, 30, 21, 13, 12, 21, 28,
  36, 43, 51,
];

type Props = {
  days: number;
  color?: string;
};

export const FakeChart = ({ days, color = "#5e6272" }: Props) => {
  const labels = Array.from({ length: days }, (_, index) => String(index + 1));
  const visibleLabels = new Set(days > 7 ? [0, 9, 19, days - 1] : [0, 3, days - 1]);

  const data: ChartData<"bar", number[], string> = {
    labels,
    datasets: [
      {
        data: previewBars.slice(0, days).map(height => height * 50),
        backgroundColor: color,
        borderRadius: 4,
        borderSkipped: false,
        barPercentage: days > 7 ? 0.8 : 0.78,
        categoryPercentage: days > 7 ? 1 : 0.92,
      },
    ],
  };

  const options: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    events: [],
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    scales: {
      x: {
        border: {
          display: false,
        },
        grid: {
          display: false,
        },
        ticks: {
          autoSkip: false,
          color: "#5e6272",
          font: {
            family: "'Inter', sans-serif",
            size: 14,
            weight: 600,
          },
          maxRotation: 0,
          minRotation: 0,
          callback: (_, index) => (visibleLabels.has(index) ? labels[index] : ""),
        },
      },
      // Fake data: the y axis only sets the scale, its labels would be meaningless
      y: {
        display: false,
        min: 0,
        max: 5000,
      },
    },
  };

  return (
    <Container aria-hidden="true">
      <Bar data={data} options={options} />
    </Container>
  );
};
